import { observer } from 'mobx-react-lite'
import type { BusinessInfoRequestedSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/business-info/BusinessInfoRequestedSupportingItemViewModel'
import { BusinessProfilesDialog } from './index'
import { BusinessProfileCardListSectionsContainer } from '@/features/jobs/details/tax-type/info-gathering/business-info/components/BusinessProfileCardListSection/BusinessProfileCardListSectionsContainer'
import { BusinessProfileEditorDialog } from '@/features/tax-profile/business-profiles/components/BusinessProfileEditorDialog'

export interface BusinessProfilesDialogContainerProps {
  vm: BusinessInfoRequestedSupportingItemViewModel
  isDisabled?: boolean
}

/**
 * Container for the business profiles dialogs that wires up the view model.
 */
export const BusinessProfilesDialogContainer = observer(
  function BusinessProfilesDialogContainer({
    vm,
    isDisabled,
  }: BusinessProfilesDialogContainerProps) {
    return (
      <>
        <BusinessProfilesDialog
          isOpen={vm.businessProfilesDialog.showing}
          onClose={vm.businessProfilesDialog.close}
        >
          <BusinessProfileCardListSectionsContainer
            vm={vm}
            isDisabled={isDisabled}
          />
        </BusinessProfilesDialog>

        <BusinessProfileEditorDialog
          vm={vm.businessProfileEditorVm}
          isDisabled={isDisabled}
        />
      </>
    )
  },
)
